import { EventTypesEnum, LessonTypesEnum, SportsEnum } from 'types/generated/client';

const DEFAULT_IMAGES_DIR = '/images/app/default-event-images';

// Template-literal forms accept both the client and server copies of each generated enum.
type ActivityTypeValue = `${EventTypesEnum | LessonTypesEnum}`;
type SportValue = `${SportsEnum}`;

const ARTWORK_BY_TYPE: Partial<Record<ActivityTypeValue, string>> = {
  [EventTypesEnum.Tournament]: 'tournament',
  [EventTypesEnum.League]: 'league',
  [EventTypesEnum.OpenPlay]: 'open-play',
  [EventTypesEnum.Social]: 'social',
};

const SPORT_SLUG: Record<SportValue, string> = {
  [SportsEnum.Pickleball]: 'pickleball',
  [SportsEnum.Tennis]: 'tennis',
  [SportsEnum.PlatformTennis]: 'tennis',
  [SportsEnum.Padel]: 'padel',
};

export interface DefaultActivityImageSource {
  type?: ActivityTypeValue | null;
  sport?: SportValue | null;
}

// Types without their own artwork (clinics, camps, general events) use the sport's court photo.
export const getDefaultActivityImage = ({ type, sport }: DefaultActivityImageSource = {}) => {
  const artwork = (type && ARTWORK_BY_TYPE[type]) || 'court';
  const sportSlug = sport ? SPORT_SLUG[sport] : SPORT_SLUG[SportsEnum.Pickleball];

  return `${DEFAULT_IMAGES_DIR}/${artwork}-${sportSlug}.webp`;
};
